'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'

/**
 * Клиент react-query для всего приложения. Создаётся один раз на маунт
 * (через useState), staleTime=60s — данные профиля переиспользуются между
 * переходами без повторных запросов, что убирает «водопад» рефетчей.
 */
export function Providers({ children }: { children: React.ReactNode }) {
	const [client] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						staleTime: 60_000,
						refetchOnWindowFocus: false,
						retry: 1,
					},
				},
			})
	)

	return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
